import React,{Component} from 'react';
import {connect} from 'react-redux';
import {Formik} from 'formik';
import * as Yup from 'yup';

import { SaveEcomLogs} from '../../apicalls/ecomlogs'
import {getSendItemsToShops,get_check_shops,get_shops_variant_quantity} from '../../apicalls/getSendItemsToShops'

import {AddItemToSkuVault} from '../../apicalls/skuVault'

class Ecom extends Component {
    constructor(){
        super()
        this.state={
            communicate:''
            };
        //creating ref for formik
        this.inputRef = React.createRef();
        this.inputText=React.createRef()
        this.inputText2=React.createRef()
        this.chooseOption=this.chooseOption.bind(this)
        this.clicked_back=this.clicked_back.bind(this)
        this.handleKeyUp=this.handleKeyUp.bind(this)
    }
    handleKeyUp(e) {
        //get the function inside the function(?)
        //asking for a key
        console.log('our props',e)
        const keys = {
        //if 27 (esc)
          27: () => {
              console.log('clciked esc')
            //prevents submit
            e.preventDefault();
            },
          13: ()=>{
            //prevents submit
            e.preventDefault();
            console.log('clicked enter',document.activeElement.name)
            if(document.activeElement.name==="upcnr"){
                this.inputText2.current.focus();
                }
            }
        }
        //if the key has ben pressed, run function to determine if it was esc
        if (keys[e.keyCode]) {
            keys[e.keyCode]();
          }
    }
    chooseOption(e){
        //here we will need to process the m_sku calls
        console.log('option clicked',e.target.value)
        }
    clicked_back(){
        this.props.dispatch({type:'MenuOption',payload:'associate_main'})
        console.log('clicked back')
        }
    show_back(clicked_back){
        if(this.props.acc_type==='associate'){
            return(
                <button className="ecom_search_button_back" onClick={clicked_back}>BACK</button>
                )
            }
        else{
            return null
            }
        }
    show_title(){
        if(this.props.acc_type==='associate'){
            return(
                <div className="ecom_description">
                    ECOM ADD
                </div>
                )
            }
        else{
            return null
            }
        }
   //while creatiung component
   componentDidMount() {
    //console.log("has mounted");
    //adding keyboard listener (keyup-press a key, handlekeyup-function which is triggered, false-?)
    window.addEventListener('keyup', this.handleKeyUp, false);
    this.inputText.current.focus();
    }
    //while unmounting component
    componentWillUnmount(){
        //we remove event listener (for keyboard)
        window.removeEventListener("keyup", this.handleKeyUp, false);
        }
    //when re-enabling component
    componentDidUpdate(prevState){
        if(prevState.communicate!==this.state.communicate){
            console.log('communicate changed')
            }
        }
    render(){
        return(
            <div className="ecom_flex">
                {this.show_title()||null}
                <Formik
                    initialValues={{ upcnr: "",location:""}} 
                    validationSchema={Yup.object().shape({
                        upcnr:Yup.string()
                        .min(11,'11 digits minimum')
                        .max(13,'13 digits maximum')
                        .required('required value'),
                        location:Yup.string()
                        .required('Location required')
                        }) 
                    }
                    displayData={(response)=>{
                    }}
                    onSubmit={(values, { setSubmitting,resetForm }) => {
                        this.setState({communicate:''})
                        console.log('clicked',values)
                        let scanned_barcode=values.upcnr.replace(/\s/g,'')
                        let scanned_location=values.location.replace(/\s/g,'')
                        let acc_ID=this.props.acc_ID
                        let timestamps=Date.now()
                        let ecom_log_bagaz={
                            barcode:scanned_barcode,
                            locationcode:scanned_location,
                            userid:acc_ID,
                            ecom_add_timestamp:timestamps
                            }
                        async function sendEcomLogs(ecom_log_bagaz){
                            let answerEcomLogs=await SaveEcomLogs(ecom_log_bagaz)
                            return answerEcomLogs
                            }
                        sendEcomLogs(ecom_log_bagaz)
                        .then(answerEcomLogs=>{
                            console.log('ecom logs',answerEcomLogs)
                            //preparing payload for shops_api_uploads (to correlate m_skus)
                            let m_sku=scanned_barcode+'-N'
                            let skuVault_bagaz={
                                sku:m_sku
                                }
                            async function checkshops(m_sku){
                                let answer_check_shops=await get_check_shops(m_sku)
                                return answer_check_shops
                                }
                            checkshops(m_sku)
                            .then(answer_check_shops=>{
                                console.log('answer from shops',answer_check_shops)
                                //if we do not have anything
                                if(answer_check_shops.data.length===0){
                                    console.log('empty array')
                                    this.setState({communicate:"no such sku in shopify"})
                                    resetForm({})
                                    this.inputText.current.focus();
                                    return
                                    }
                                else{
                                    let skuVault_bagaz={
                                        Code:scanned_barcode,
                                        LocationCode:scanned_location,
                                        }
                                    console.log('we have something')
                                    //we go to skuVault
                                    async function addItem(skuVault_bagaz){
                                        let answerAddItem=await AddItemToSkuVault(skuVault_bagaz)
                                        return answerAddItem
                                        }
                                    addItem(skuVault_bagaz)
                                    .then(answerAddItem=>{
                                        console.log('asnwer from skuVault',answerAddItem)
                                        if(answerAddItem.data.AddItemStatus==="Success"){
                                            this.setState({communicate:"Item Added"})
                                            }
                                        else{
                                            if(answerAddItem.data.AddItemStatus==="LocationNotFound"){
                                                this.setState({communicate:"Unknown Location"})
                                                }
                                            else{
                                                this.setState({communicate:"error. please try again"})    
                                                }
                                            }
                                        resetForm({})
                                        this.inputText.current.focus();
                                        return
                                        })
                                    }
                                })
                            })
                        }}
                    >
                {props => {
                    const {
                    values,
                    touched,
                    errors,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    resetForm
                    } = props;
                    
                    return(
                        <form onSubmit={handleSubmit} ref={this.inputRef}>
                            <div className="ecom_search_bar">
                                <div className="ecom_search_title">
                                    BARCODE
                                </div>
                                <input className="ecom_search_input"
                                ref={this.inputText}
                                name="upcnr"
                                type="text"
                                placeholder="numbers only"
                                value={values.upcnr}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                    />
                                <div className="ecom_FormikErrors">{errors.upcnr||'\u00a0'}</div>
                            </div>
                            <div className="ecom_search_bar">
                                <div className="ecom_search_title">
                                    LOCATION
                                </div>
                                <input  className="ecom_search_input"
                                    ref={this.inputText2}
                                    name="location"
                                    type="text"
                                    placeholder="location id"
                                    value={values.location}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    />
                                <div className="ecom_FormikErrors">{errors.location||'\u00a0'}</div>
                            </div>
                            <button className="ecom_search_button_confirm" type="submit"  disabled={isSubmitting} >CONFIRM</button>
                            <button className="ecom_search_button_clear" type="button" onClick={(e) =>resetForm({})}>CLEAR</button>
                            {   this.show_back(this.clicked_back)||null}
                            <div className="ecom_FormikErrors">
                                {this.state.communicate||'\u00a0'}
                            </div>
                        </form>
                    )
                    }}
                </Formik>
            </div>
            )
    }
}
const mapStateToProps=(state)=>({
    LOGGED:state.LOGGED,
    MenuOption:state.MenuOption,
    acc_type:state.acc_type,
    acc_ID:state.acc_ID
    })
export default connect(mapStateToProps)(Ecom);